<p-toast position="top-center"></p-toast>
<p-confirmDialog></p-confirmDialog>

<router-outlet></router-outlet>
<app-debug *ngIf="showDebugger()"></app-debug>
